import { useBondsTileTabContext } from '@/creditflowresearch/application/Bonds/BondsTileTabContext';
import TabSelect from '@/creditflowresearch/ui/components/bondscreener/TabSelect';
import { BWICS, INVENTORIES, TBondType } from '@/creditflowresearch/domain/BondType';

const BOND_TYPE_TABS: Record<TBondType, { name: string }> = {
  [BWICS]: { name: 'BWICS' },
  [INVENTORIES]: { name: 'Inventory' },
};

const BondTypesTabSelect = () => {
  const { activeTab, setActiveTab } = useBondsTileTabContext();

  return (
    <TabSelect
      tabs={ BOND_TYPE_TABS }
      activeTab={ activeTab }
      onChangeTab={ setActiveTab }
      dataTest="bondTypesTabSelect"
    />
  );
};

export default BondTypesTabSelect;
